<!-- Main content -->
<div class="container m-t-alt" *ngIf="document">
  <div class="columns">
    <div
      class="column is-12-mobile is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"
    >
      <app-breadcrumbs
        [darkTheme]="false"
        [breadcrumbLinks]="breadcrumbLinks"
        *ngIf="breadcrumbLinks"
      ></app-breadcrumbs>

      <h1 class="title is-1" *ngIf="document">
        {{ document.name }}
      </h1>
      <div
        class="flex align-center-tablet space-between dir-col-mobile justify-start-mobile align-start-mobile"
      >
        <p class="small-meta">
          <span
            class="has-text-link"
            *ngFor="let stakeholderType of document.stakeholderTypes"
            >{{ stakeholderType.name }} </span
          ><ng-container
            *ngIf="
              document.stakeholderTypes && document.stakeholderTypes.length
            "
            >&nbsp;|&nbsp;</ng-container
          >
          <span class="m-x-xs">
            {{ document.date | date : 'LLLL d, yyyy' }}</span
          >
        </p>
        <app-social-share
          [title]="document.name"
          *ngIf="document"
          [darkTheme]="false"
        ></app-social-share>
      </div>
      <div class="tag-group m-y-lg">
        <span
          class="tag is-danger m-r-xs m-b-0"
          *ngFor="let AIPrinciple of document.AIPrinciples"
          >{{ AIPrinciple.name }}</span
        >
        <span
          class="tag is-primary m-r-xs m-b-0"
          *ngFor="let policyArea of document.policyAreas"
          >{{ policyArea.name }}</span
        >
      </div>

      <div class="article-wrapper">
        <div
          class="flex flex-column align-start justify-start is-full-height m-b-lg article"
        >
          <p>
            {{ document.description }}
          </p>
          <div class="card flex align-center full-width space-between">
            <div class="m-r-gutter">
              <a
                class="ghost flex align-center flex-start"
                [href]="document.path"
                target="_blank"
                download
              >
                <i
                  class="icon is-size-2"
                  [ngClass]="{
                    'icon-circle-excel': mime === FileMime.Excel,
                    'icon-circle-acrobat': mime === FileMime.Pdf,
                    'icon-circle-powerpoint': mime === FileMime.Ppt,
                    'icon-Download has-text-oecd-blue': mime === FileMime.Other
                  }"
                ></i>
                <span
                  i18n="@@documentDetailDownload"
                  class="p-x-lg has-text-link is-bold is-underline"
                >
                  Download {{ document.name }}
                </span>
              </a>
            </div>
            <a
              class="ghost flex align-center flex-start"
              [href]="document.path"
              target="_blank"
              download
            >
              <i class="icon icon-Download1 is-size-2 has-text-link"></i>
            </a>
          </div>
        </div>

        <!-- Share box -->
        <div class="share-box flex align-center space-between p-b-gutter">
          <span i18n="@@documentDetailShare">Share it :</span>
          <app-social-share
            [title]="document.name"
            [darkTheme]="false"
          ></app-social-share>
        </div>
      </div>
      <hr class="m-t-0 m-b-xl" />
      <div class="post-meta-author m-b-gutter flex space-between align-start">
        <div class="card card--author bg-transparent">
          <!-- Author -->
          <ng-container
            *ngIf="!workingGroup && (!coAuthors || !coAuthors.length)"
          >
            <a
              [routerLink]="['/community', document.author.slug]"
              class="ghost"
            >
              <figure class="avatar m-t-0">
                <img
                  [src]="authorImage.square"
                  [alt]="document.author.name"
                  *ngIf="authorImage"
                />
                <img
                  src="./assets/images/default-author.svg"
                  [alt]="document.author.name"
                  *ngIf="!authorImage"
                />
              </figure>
            </a>
            <div class="m-l-gutter-mobile">
              <p class="m-y-0">
                <a
                  [routerLink]="['/community', document.author.slug]"
                  class="ghost is-bold small-meta"
                  >{{ document.author.name }}</a
                >
              </p>
              <p class="m-y-0">
                <span class="small-meta is-bold">
                  <a
                    [routerLink]="['/community', document.author.slug]"
                    class="ghost"
                    >{{ document.author.position
                    }}<ng-container
                      *ngIf="
                        document.author.position && document.author.institution
                      "
                      >, </ng-container
                    >{{ document.author.institution }}</a
                  >
                </span>
              </p>
            </div>
          </ng-container>

          <!-- Multiple authors (Author plus co-authors) -->
          <ng-container *ngIf="!workingGroup && coAuthors && coAuthors.length">
            <a
              [routerLink]="['/community', document.author.slug]"
              class="ghost"
            >
              <figure class="avatar m-t-0">
                <img
                  [src]="authorImage.square"
                  [alt]="document.author.name"
                  *ngIf="authorImage"
                />
                <img
                  src="./assets/images/default-author.svg"
                  [alt]="document.author.name"
                  *ngIf="!authorImage"
                />
              </figure>
            </a>
            <a
              [routerLink]="['/community', coAuthor.slug]"
              class="ghost author-link-avatar"
              *ngFor="let coAuthor of coAuthors"
            >
              <figure class="avatar m-t-0">
                <img
                  [src]="coAuthor.image.square"
                  [alt]="coAuthor.name"
                  *ngIf="coAuthor.image"
                />
                <img
                  src="./assets/images/default-author.svg"
                  [alt]="coAuthor.name"
                  *ngIf="!coAuthor.image"
                />
              </figure>
            </a>

            <div>
              <p class="m-y-0">
                <a
                  [routerLink]="['/community', document.author.slug]"
                  class="ghost is-bold small-meta"
                  >{{ document.author.name }}</a
                >
                <a
                  [routerLink]="['/community', coAuthor.slug]"
                  class="ghost is-bold small-meta"
                  *ngFor="let coAuthor of coAuthors"
                  >, {{ coAuthor.name }}</a
                >
              </p>
            </div>
          </ng-container>

          <!-- Working group -->
          <ng-container *ngIf="workingGroup">
            <a
              [routerLink]="[
                '/network-of-experts',
                'working-group',
                workingGroup.id
              ]"
              class="ghost"
            >
              <figure class="avatar m-t-0">
                <img
                  [src]="workingGroup.image.square"
                  [alt]="workingGroup.name"
                  *ngIf="workingGroup.image"
                />
                <img
                  src="./assets/images/default-authors.svg"
                  [alt]="workingGroup.name"
                  *ngIf="!workingGroup.image"
                />
              </figure>
            </a>
            <div>
              <p class="m-y-0">
                <a
                  [routerLink]="[
                    '/network-of-experts',
                    'working-group',
                    workingGroup.id
                  ]"
                  class="ghost is-bold small-meta"
                  >{{ workingGroup.name }}</a
                >
              </p>
            </div>
          </ng-container>
        </div>
      </div>

      <app-author-disclaimer></app-author-disclaimer>
    </div>
  </div>
</div>

<div
  class="container-full bg-gradient"
  *ngIf="relatedPosts && relatedPosts.length"
>
  <div class="container p-y-xl">
    <div class="columns">
      <div class="column is-12">
        <h3 i18n="@@documentDetailPosts" class="title is-3 has-tex-black">
          From the AI Wonk
        </h3>
      </div>
    </div>
    <div class="columns flex flex-wrap">
      <div
        class="column is-12-mobile is-6-tablet is-4-desktop"
        *ngFor="let relatedPost of relatedPosts"
      >
        <app-post-card [post]="relatedPost"></app-post-card>
      </div>
    </div>
  </div>
</div>

<div class="container-full bg-gradient" *ngIf="loadingRelatedPosts">
  <div class="container p-y-xl">
    <div class="columns">
      <div class="column is-12">
        <h3 i18n="@@documentDetailRelated" class="title is-3 has-tex-black">
          From the AI Wonk
        </h3>
      </div>
    </div>
    <div class="columns flex flex-wrap">
      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <div class="lc lc--white lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <div class="lc lc--white lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <div class="lc lc--white lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</div>
